<template>
    <div>
        <!-- Alert Messages -->
        <div v-if="msg !== ''" class="row mt-n2 mb-5">
            <div class="col-12">
                <div :class="`alert alert-${color} text-center mb-n5 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </div>
        </div>
        <!-- Cover Photo -->
        <div v-if="kind == 'cover'" class="row">
            <div class="col-12">
                <div class="cover-container mx-auto">
                    <img ref="image" :src="src">
                    <button @click.prevent="uploadCroppedCover" class="loadn btn btn-light-green btn-sm form-control my-2">
                        Upload <i class="fas fa-cloud-upload-alt"></i>
                    </button>
                    <button @click.prevent="closeCropFxn" class="btn btn-link text-danger btn-sm form-control">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
        <!-- Display Photo -->
        <div v-else class="row">
            <div class="col-12">
                <div class="dp-container mx-auto">
                    <img ref="image" :src="src">
                    <button @click.prevent="uploadCroppedDp" class="loadn btn btn-light-green btn-sm form-control my-2">
                        Upload <i class="fas fa-cloud-upload-alt"></i>
                    </button>
                    <button @click.prevent="closeCropFxn" class="btn btn-link text-danger btn-sm form-control">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import axios from 'axios';
import Cropper from 'cropperjs';

export default {
    name: "ImageCropper",
    props: {
        src: String,
        kind: String
    },
    data() {
        return {
            cropper: {},
            image: {},
            msg: '',
            color: 'danger',
        }
    },
    methods: {
        ...mapActions(['updateUserVal']),
        uploadCroppedCover() {
            this.cropper.getCroppedCanvas().toBlob( async (blob) => {
                const formData = new FormData();
                // pass the cropped image directly to formData for axios
                formData.append('userId', this.user._id);
                formData.append('cover', blob);
                let response = await axios.post(`/media/cover`, formData)
                if(!response.data.error){
                    // update the dp display
                    this.updateUserVal(response.data.result)
                    // display alert
                    this.color = "success"
                    this.msg = response.data.msg
                } else {
                    this.color = "danger"
                    this.msg = "Upload failed! File maybe bad or cropped too large, try again."
                }
            })
        },
        uploadCroppedDp() {
            this.cropper.getCroppedCanvas().toBlob( async (blob) => {
                const formData = new FormData();
                // pass the cropped image directly to formData for axios
                formData.append('userId', this.user._id);
                formData.append('dp', blob);
                let response = await axios.post(`/media/dp`, formData)
                if(!response.data.error){
                    // update the dp display
                    this.updateUserVal(response.data.result)
                    // display alert
                    this.color = "success"
                    this.msg = response.data.msg
                } else {
                    this.color = "danger"
                    this.msg = "Upload failed! File maybe bad or cropped too large, try again."
                }
            })
        },
        closeCropFxn() {
            this.$emit('closeCrop', true)
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    mounted() {
        this.image = this.$refs.image
        this.cropper = new Cropper(this.image, {
            aspectRatio: this.kind == 'cover' ? 16 / 3 : 1
        })
    },
}
</script>

<style scoped>
img {
  display: block;
  /* This rule is very important, please don't ignore this */
  max-width: 100%;
}
.dp-container {
    width: 200px;
    height: 200px;
}
.cover-container {
    width: 100%;
    height: 150px;
}
</style>